import { MERCHANT_ADMIN_MEMBER_LIST } from "constants/action-types";
import { setErrorMessage, fetchMembers, resetMembers } from "actions/merchant-admin-member-list-actions";
import { IFetchParams, progressEpic } from "./base-epic";
import { IMembersPayload } from "reducers/merchant-admin-member-list-reducers";
import { pickGrpcError } from "helpers/epics";
import { Observable } from "rxjs";
import siteConfig from "site-config";
import { ajax } from "lib/observable";

export const fetchMembersEpic = progressEpic<IFetchParams, IMembersPayload>(
    MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.FETCH,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
        body: payload.body,
    }),
);

export const addMembersEpic = (action$, store) => {
    return action$
        .ofType(MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.ADD.START)
        .switchMap(({ payload: { merchantId, adminTeamId, memberIds } }) => {
            return Observable.range(0, memberIds.length) // hack to make this thing keep going
                .concatMap((currentIndex) => {
                    const memberId = memberIds[currentIndex];
                    return ajax({
                        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/teams/${adminTeamId}/members`,
                        method: "POST",
                        body: { member_id: memberId },
                    }).concatMap(() => {
                        if (currentIndex >= memberIds.length - 1) {
                            store.dispatch({
                                type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.ADD.SUCCESS,
                                payload: {
                                    merchantId,
                                    adminTeamId,
                                },
                            });
                        }
                        return Observable.empty();
                    });
                })
                .takeUntil(action$.ofType(MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.ADD.SUCCESS))
                .catch(() => {
                    return Observable.of({
                        type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.ADD.SUCCESS,
                        payload: {
                            merchantId,
                            adminTeamId,
                        },
                    });
                });
        });
};

export const resetAndRefetchMembersEpic = (action$) => {
    return action$
        .ofType(MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.ADD.SUCCESS)
        .map(({ payload }) => payload)
        .concatMap(({ merchantId, adminTeamId }) => {
            return Observable.merge(
                Observable.of(resetMembers()),
                Observable.of(fetchMembers(merchantId, adminTeamId, {})),
            );
        });
};

export const deactivateMemberEpic = progressEpic<IFetchParams, never>(
    MERCHANT_ADMIN_MEMBER_LIST.MEMBER.DEACTIVATE,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
    }),
    {
        errorActions: (error) => [setErrorMessage(pickGrpcError(error))],
    },
);

export const activateMemberEpic = progressEpic<IFetchParams, never>(
    MERCHANT_ADMIN_MEMBER_LIST.MEMBER.ACTIVATE,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
    }),
    {
        errorActions: (error) => [setErrorMessage(pickGrpcError(error))],
    },
);
